export default __webpack_public_path__ + "static/media/Circleci-icon-logo.0ae5a3ac.svg";